import React from 'react'
import PropTypes from 'prop-types'

import { currencyFormat } from 'utils/format'
import { dateToBR } from 'utils/date'

import DescItemInfo from 'ui-components/DescItemInfo/DescItemInfo'
import { Checkbox } from 'ui-components/Checkbox'
import { Pending, Title } from './styles'

export default function Vouchers(props) {
  const {
    vouchers,
    selectedVouchers,
    onSelect,
    onDeselect,
  } = props

  const wasSelected = (id) => {
    const selected = selectedVouchers.filter((item) => Number(item.id) === Number(id))
    return Boolean(selected.length)
  }

  const handleCheckboxClick = (voucher) => (event) => {
    const { checked } = event.target

    if (checked) return onSelect(voucher)
    return onDeselect(voucher)
  }

  const renderVoucher = (voucher) => (
    <Pending key={`voucher-${voucher.id}`}>
      <DescItemInfo label="">
        <Checkbox
          color="primary"
          checked={wasSelected(voucher.id)}
          onChange={handleCheckboxClick(voucher)}
        />

      </DescItemInfo>

      <DescItemInfo label="Data">
        { dateToBR(voucher.attributes.date) }
      </DescItemInfo>

      <DescItemInfo label="Número">
        { voucher.attributes.code }
      </DescItemInfo>

      <DescItemInfo label="R$ Valor">
        { currencyFormat(voucher.attributes.value) }
      </DescItemInfo>
    </Pending>
  )

  return !vouchers.length ? null : (
    <div>
      <Title>Há vouchers disponíveis. Selecione para usar no pagamento:</Title>
      { vouchers.map(renderVoucher) }
    </div>
  )
}

Vouchers.propTypes = {
  vouchers: PropTypes.arrayOf(PropTypes.object),
  selectedVouchers: PropTypes.arrayOf(PropTypes.object),
  onSelect: PropTypes.func.isRequired,
  onDeselect: PropTypes.func.isRequired,
}

Vouchers.defaultProps = {
  vouchers: [],
  selectedVouchers: [],
}
